import Vue from 'vue';

import Union from "./components/Union.vue";

var unionComponent = document.getElementById('union');

if (typeof (unionComponent) != 'undefined' && unionComponent != null) {

    new Vue({
        el: "#union",
        components: { Union }
    });
}

import Agreement from "./components/Agreement.vue";

var agreementComponent = document.getElementById('agreement');

if (typeof (agreementComponent) != 'undefined' && agreementComponent != null) {

    new Vue({
        el: "#agreement",
        components: { Agreement }
    });
}



// WEBPACK FOOTER //
// ./Scripts/app/union/union.js